var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1283,
    height: 360,
    viewBox: "0 0 1283 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 322C94.2854 354.691 66.3176 363.967 2 355V190H1281V343C1263.83 349.333 1224.1 353.5 1202.5 319.5C1166.1 325.5 1143 303.333 1136 291.5C1136 291.5 1056.65 329.049 1013 294C979.561 321.894 955.809 325.941 912 305C815.59 348.255 759.687 352.269 666.5 307.5C629.14 322.672 610.25 321.397 579 307.5C523.835 328.038 488.485 342.409 418.5 294C391.522 309.998 376.287 310.363 349 302C306.148 319.075 284.26 314.421 248 294C208.706 329.205 183.952 335.822 134.5 322Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 1279,
    height: 202,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.76eb00de563f591d72160fbcf90c9c6e.svg";
export { ForwardRef as ReactComponent };